import { Component, EventEmitter, AfterContentInit, Input, ContentChild, Output, TemplateRef, forwardRef, ViewChild, ElementRef, Renderer2, HostBinding } from '@angular/core';
import { ExaFooter, ExaTemplate, ExaHeader } from '../common/shared';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

declare var $: any;

const EXACOMBOBOX_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ExaComboboxComponent),
  multi: true
};

@Component({
  selector: 'exa-combobox',
  providers: [EXACOMBOBOX_VALUE_ACCESSOR],
  templateUrl: './exa-combobox.component.html',
  styleUrls: ['./exa-combobox.component.css']
})
export class ExaComboboxComponent implements ControlValueAccessor, AfterContentInit {
  @Input() optionKey: string = "id";
  @Input() maxOptions: number = 20;

  @ViewChild('inputSearch') inputSearch: ElementRef;
  @ViewChild('cbb') cbb: ElementRef;

  // le chiavi da usare come label  devono essere separte da una virgola
  _optionLabel = ["value"];
  @Input() set optionLabel(val: string) {
    this._optionLabel = val.split(",");
  }

  // le chiavi da usare per l'ordinamento della lista devono essere separte da una virgola
  _optionSortKey = [];
  @Input() set optionSortKey(val: string) {
    this._optionSortKey = val.split(",");
  }

  @Input() multiSelect: boolean = false;

  @Output() change = new EventEmitter<any>();
  @Output() click = new EventEmitter<any>();

  selectedValues: any[] = [];
  countSelectedValues: number = 0;

  @Input() options: any[];

  _readonly = false;
  @Input() set readonly(val: boolean) {
    this._readonly = val;
    this.setDisabledState(val);
  }

  get readonly() {
    return this._readonly;
  }
  
  @HostBinding('attr.readonly')
  public get isReadonly(): Boolean {
      if (this.readonly) return true;

      return null;
  }

  @ContentChild(ExaHeader) headerFacet;
  @ContentChild(ExaFooter) footerFacet;
  @ContentChild(ExaTemplate) exaTemplate: any;

  public container: HTMLDivElement;

  public itemTemplate: TemplateRef<any>;

  multiSelectMode: boolean = false;

  filtro: string = '';
  value: any;

  onModelChange: Function = () => { };

  onModelTouched: Function = () => { };

  setDisabledState(isDisabled: boolean): void {
    this._readonly = isDisabled;
    this.renderer.setProperty(this.el.nativeElement, 'disabled', isDisabled);
  }

  id = new Date().getTime();
  getId() {
    return 'dropdown' + this.id;
  }

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) { }

  showSelectedValue() {
    if (this.value != null) {
      if (this.multiSelect) {
        let arr = [];
        for (let key of this.value) {
          arr.push(this.getLabel(this.getOption(key)))
        }
        return arr.join(", ")
      }
      else {
        return this.getLabel(this.getOption(this.value));
      }
    }
    return "";
  }

  writeValue(value: any): void {
    /*
    if(this.filter) {
        this.resetFilter();
    }
    */

    this.selectedValues = [];
    this.countSelectedValues = 0;
    if (value != null) {
      this.value = value;

      if (this.multiSelect) {
        let arr = value as Array<any>;
        for (let o of this.value) {

          let opt = this.getOption(o);
          if (opt != null) {
            this.selectedValues[o] = opt;
            this.countSelectedValues++;
          }
        }
      } else {
        let opt = this.getOption(this.value);
        if (opt != null) {
          this.selectedValues[this.value] = opt;
          this.countSelectedValues++;
        }
      }
    }
    this.multiSelectMode = this.countSelectedValues > 1;

    /*
    this.updateSelectedOption(value);
    this.updateEditableLabel();
    this.updateFilledState();
    this.cd.markForCheck();*/
  }

  registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }

  getOption(key) {
    for (let opt of this.getOptions()) {
      if ('' + opt[this.optionKey] == '' + key) {
        return opt;
      }
    }

    return null;
  }

  getLabel(option) {
    if (!option) return "";

    let lbl = "";
    for (let key of this._optionLabel) {
      let val = option[key];
      if (val != null)
        lbl += val.trim() + " ";
      else
        return null;
    }

    return lbl.trim();
  }

  getSortKey(option) {
    if (!option) return "";

    let lbl = "";
    for (let key of this._optionSortKey) {
      let val = '' + option[key];
      if (val != null)
        lbl += val.trim() + " ";
      else
        return null;
    }

    return lbl.trim();
  }

  reset(evt) {
    if (this.readonly) {
      evt.stopPropagation();
      return;
    }
    /*
    this.countSelectedValues = 0;
    this.selectedValues = [];
    this.multiSelectMode = false;
    */
    this.filtro = '';
    if (this.inputSearch)
      this.inputSearch.nativeElement.value = "";
    this.options = this.getOptions().sort((v1, v2) => {

      for (let key of this._optionSortKey) {
        let val1 = v1[key];
        let val2 = v2[key];
        if (val1 == null && val2 == null) return 0;
        if (val1 != null && val2 == null) return 1;
        if (val1 == null && val2 != null) return -1;

        if (typeof val1 != typeof val2) return 0;

        let diff = 0;
        if (typeof val1 == 'number') {
          diff = val1 - val2;
        } else {
          diff = val1.toLowerCase().localeCompare(val2.toLowerCase())
        }
        if (diff != 0)
          return diff;

      }
      return 0;
    });
    if (this.click.observers.length > 0)
      $(this.cbb.nativeElement).click();
    //    $(this.cbb.nativeElement).dropdown('toggle');
    /*
        evt.cancelBubble = true;
    
        evt.stopPropagation();
        $(this.cbb.nativeElement).children()[0].click();
        */
    //this.click.next({bubbles: true});
  }

  ngOnInit() {
    // Se non indico chiavi per l'ordinamento uso la label
    if (this._optionSortKey.length == 0)
      this._optionSortKey = this._optionLabel;
  }

  ngAfterContentInit() {
    if (this.exaTemplate)
      this.itemTemplate = this.exaTemplate.template;
  }

  isSelected(value) {
    return this.selectedValues["" + value[this.optionKey]] != null;
  }

  onItemClick(event, v, chkbx = false) {
    if (!this.multiSelect) {
      this.countSelectedValues = 0;
      this.selectedValues = [];
      this.multiSelectMode = false;
    }

    let val = v[this.optionKey];
    let old = this.countSelectedValues;

    if (!this.selectedValues["" + val]) {
      this.countSelectedValues++;
      this.selectedValues["" + val] = v;
    } else {
      this.countSelectedValues--;
      this.selectedValues["" + val] = null;
    }
    this.multiSelectMode = this.countSelectedValues > 1;

    if (chkbx) {
      event.stopPropagation();
    } else {
      if (this.countSelectedValues == 1 && old == 0) {

      } else {
        event.stopPropagation();
      }
    }
    this.value = this.getControlValue();
    this.onModelChange(this.value);
    this.change.emit(this.value);
  }

  getControlValue() {
    if (!this.multiSelect) {
      for (let o in this.selectedValues) {
        return o;
      }
    } else {
      let arr = [];
      this.selectedValues.forEach(o => {
        if (o != null)
          arr.push(o[this.optionKey]);
      })

      return arr;
    }
  }

  getOptions() {
    if (this.options != null) return this.options;

    return [];
  }

  getSelectedValue() {
    let arr = [];
    for (let val in this.selectedValues) {
      if (this.selectedValues[val])
        arr.push(this.selectedValues[val]);
    }

    return arr;
  }

  isSelectedAll() {
    return this.countSelectedValues == this.getOptions().length;
  }

  onItemClickAll(evt) {
    evt.stopPropagation();

    for (let opt of this.getOptions()) {
      let key = "" + opt[this.optionKey];
      if (this.isSelectedAll()) {
        this.selectedValues[key] = null;
      } else {
        this.selectedValues[key] = opt;
      }
    }

    if (this.isSelectedAll())
      this.countSelectedValues = 0;
    else
      this.countSelectedValues = this.getOptions().length;

    this.multiSelectMode = this.countSelectedValues != 0;

    this.value = this.getControlValue();
    this.onModelChange(this.value);
    this.change.emit(this.value);
  }

  filtraOpzioni(val) {
    this.filtro = val;
  }

  getFilteredOptions() {
    if (this.filtro == "")
      return this.getOptions();
    else {
      let arr = [];

      for (let opt of this.getOptions()) {
        if (this.getLabel(opt).toLowerCase().indexOf(this.filtro.toLowerCase()) >= 0) {
          arr.push(opt);
        }
      }

      return arr;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/exa/exa-combobox/exa-combobox.component.ts